exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tr_loading {\n  height: 100%;\n  background: #E6EAF9;\n  text-align: center;\n  padding-top: 10%;\n}", "", {"version":3,"sources":["F:/workSpace/eclipse/branch/mcFroutendTemp/src/components/extension_turn.vue"],"names":[],"mappings":";AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;CAClB","file":"extension_turn.vue","sourcesContent":[".tr_loading {\n  height: 100%;\n  background: #E6EAF9;\n  text-align: center;\n  padding-top: 10%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b978fe6","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/extension_turn.vue
// module id = O1yV
// module chunks = 1